module.exports = __webpack_public_path__ + "img/snow_fall_00012.5e661ee8.png";